module.exports = __webpack_public_path__ + "static/media/connectApp.89604c58.svg";